import { useEffect, useMemo, useState } from "react"
import { userFields, UserModel, gridFormFieldType, deepCopy } from "./Atom"
import UsersAPI from "../../../../api/users"
import { getTokenLocal } from "../../../../helper/utils"
import { useResponseHandle } from "../../../hooks"
import { useNavigate } from "react-router-dom"
import MetricAPI from "../../../../api/metric"
import { Typography } from "@mui/material"
import { toast } from "react-toastify"
import { useDispatch } from "react-redux"
import {
  setNewUserGroups,
  setNewUserPractices,
} from "../../../redux/slices/usersSlice"
import { useSelector } from "react-redux"

const usersAPI = new UsersAPI()
const metricAPI = new MetricAPI()

const CreateNewUserModal = (props: any) => {
  const { open, setOpen, sendInvitation, fetchUsersData } = props

  const dispatch = useDispatch()

  const newUserPractices = useSelector((state: any) => {
    return state.users.newUserPractices
  })
  const newUserGroups = useSelector((state: any) => {
    return state.users.newUserGroups
  })

  const [formState, setformState] = useState(deepCopy(userFields))
  const [globalError, setGlobalError] = useState<string>("")
  // const [groups, setGroups] = useState<any>([])
  const [selectedGroupSk, setSelectedGroupSk] = useState<any>(
    newUserGroups[0]?.group_sk,
  )
  // const [practices, setPractices] = useState<any>([])
  const [flag, setFlag] = useState<any>(false)

  const groupField = useMemo(() => {
    return {
      label: "Select a group",
      type: "text",
      placeHolder: "Select group",
      componentType: 2,
      value: "",
      error: false,
      options: {
        data: newUserGroups,
        key: "group_sk",
        value: "group_name",
      },
    } as gridFormFieldType
  }, [newUserGroups])

  const practiceField = useMemo(() => {
    return {
      label: "Select a practice",
      type: "text",
      placeHolder: "Select practice",
      componentType: 2,
      value: "",
      error: false,
      options: {
        data: newUserPractices,
        key: "name",
        value: "name",
        multiSelect: true,
      },
    } as gridFormFieldType
  }, [newUserPractices, flag])

  const token = getTokenLocal()
  const navigate = useNavigate()
  const [loading, setLoading] = useState<{
    now: boolean
    message: string | JSX.Element | null
  }>({
    now: true,
    message: null,
  })

  const handleClose = () => {
    setformState((prev) => {
      let newState = deepCopy(userFields)
      newState[0].options = prev?.[0]?.options

      return newState
    })
    setGlobalError("")
    setLoading({ now: false, message: null })
    setOpen(false)
  }
  const getRoles = async () => {
    if (token) {
      setLoading({ now: true, message: "loading please wait..." })
      const response = await usersAPI.getAllUserRoles(token as string)
      const result = useResponseHandle({
        apiResponse: response,
        successMessage: false,
      })

      if (result?.isAuthorized) {
        setformState((prev: any) => {
          const newState = [...prev]
          newState[0].component_type = 2
          newState[0].options = {
            data: result?.data,
            key: "role_category",
            value: "role_display_name",
            multiselect: false,
          }
          return newState
        })
      } else {
        navigate("/auth")
      }
    }
    setLoading((prev) => ({ ...prev, now: false }))
  }
  const getGroups = async () => {
    if (token) {
      const response = await metricAPI.getMetricGroups(token as string)
      const result = useResponseHandle({
        apiResponse: response,
        successMessage: false,
      })

      if (result?.isAuthorized) {
        dispatch(setNewUserGroups(result?.data))
        setSelectedGroupSk(result?.data?.[0]?.group_sk)
      } else {
        navigate("/auth")
      }
    }
  }

  const getPratices = async () => {
    if (token) {
      const response = await metricAPI.getMetricPracticesByGroups(
        token as string,
        [selectedGroupSk],
      )
      const result = useResponseHandle({
        apiResponse: response,
        successMessage: false,
      })

      if (result?.isAuthorized) {
        dispatch(setNewUserPractices(result?.data))
      } else {
        navigate("/auth")
      }
    }
  }

  useEffect(() => {
    getRoles()
    getGroups()
  }, [])

  useEffect(() => {
    getPratices()
  }, [flag])

  useEffect(() => {
    setLoading((prev) => ({ ...prev, now: true }))
  }, [])

  useEffect(() => {
    if (
      formState[0]?.options &&
      formState[4]?.options &&
      formState[5]?.options
    ) {
      setLoading((prev) => ({ ...prev, now: false }))
    }
  }, [formState, newUserPractices])

  useEffect(() => {
    if (formState[5]?.options) {
      formState[5].options.data = newUserPractices
    }
  }, [newUserPractices])

  const submitHandler = async (payload: any) => {
    setLoading({
      now: true,
      message: (
        <Typography>
          Creating "{payload["Select Role"]}" user <b>{payload["Full Name"]}</b>{" "}
          and sending invite to <b>{payload["Email"]}</b>...
        </Typography>
      ),
    })
    const nameArr = payload["Full Name"]?.split(" ")
    let data: any = {
      email: payload.Email,
      password: payload.Password,
      first_name: nameArr[0],
      last_name: nameArr[1],
      role_id: formState?.[0]?.options?.data?.find((role: any) => {
        return role.role_display_name === payload["Select Role"]
      })?.role_id,
      role_category: formState?.[0]?.options?.data?.find((role: any) => {
        return role.role_display_name === payload["Select Role"]
      })?.role_category,
    }
    let assigned_groups = []
    if (data.role_category !== "admin") {
      const selectedGroup = newUserGroups?.find((item: any) => {
        return item.group_name === payload["Select a group"]
      })
      selectedGroup && assigned_groups.push((selectedGroup as any)?.group_sk)
    }
    data["group_sk"] = assigned_groups

    let assigned_practices: any = []

    const selectedPractices = payload["Select a practice"]

    if (data.role_category == "office_manager") {
      selectedPractices?.forEach((practice: any) => {
        assigned_practices.push(practice?.practice_sk)
      })
    }

    data["practice_sk"] = assigned_practices

    const response = await sendInvitation(data)

    if (response?.status !== 200) {
      setLoading({ now: false, message: null })
      return setGlobalError(
        response?.data.display_message ||
          "Something went wrong, please contact dev team",
      )
    }
    toast.success(
      `User ${data?.first_name || ""} ${
        data?.last_name || ""
      } created successfully`,
    )
    await fetchUsersData()
    handleClose()
  }

  const stateHandler = (newState: gridFormFieldType[], index: number) => {
    let merge = false

    if (index === 4) {
      const selectedGroup = newUserGroups?.find((item: any) => {
        return item.group_name === newState[4].value
      })

      // console.log("selectedGroup",);

      setSelectedGroupSk(selectedGroup?.group_sk)

      if (practiceField?.options) {
        practiceField.options.data = newUserPractices
      }
    }

    if (index === 0) {
      const selectedRole = newState[0]?.options?.data?.find((item: any) => {
        return item.role_display_name === newState[0].value
      })

      if (selectedRole?.role_category == "office_manager") {
        merge = true
        groupField.placeHolder = "Select a group"
        groupField.value = null
        practiceField.placeHolder = "Select a practice"
        practiceField.value = null
      } else if (
        selectedRole?.role_category !== "admin" &&
        selectedRole?.role_category != "office_manager"
      ) {
        merge = true
        groupField.placeHolder = "Select a group"
        groupField.value = null

        if (newState.length > 5) {
          newState.pop()
        }
      } else {
        if (newState.length > 5) {
          newState.pop()
          newState.pop()
        } else if (newState.length > 4) {
          newState.pop()
        }
      }

      if (
        merge &&
        newState.length === 5 &&
        selectedRole?.role_category == "office_manager"
      ) {
        if (newState.length > 5) {
          newState[5] = practiceField
        } else {
          newState = newState.concat([practiceField])
        }
      } else if (
        merge &&
        newState.length === 4 &&
        selectedRole?.role_category != "office_manager"
      ) {
        if (newState.length > 4) {
          newState[4] = groupField
        } else {
          newState = newState.concat([groupField])
        }
      } else if (
        merge &&
        newState.length === 4 &&
        selectedRole?.role_category == "office_manager"
      ) {
        if (newState.length > 4) {
          newState[4] = groupField
          newState[5] = practiceField
        } else {
          newState = newState.concat([groupField])
          newState = newState.concat([practiceField])
        }
      }
    }

    setformState(newState)
  }

  useEffect(()=>{
    if(open){
      getRoles();
    }
  },[open])

  return (
    <UserModel
      globalError={globalError}
      formTitle="Invite New User"
      loading={loading}
      formState={formState}
      setState={stateHandler}
      open={open}
      closeHandler={handleClose}
      optionalText={
        "An invitation will be sent to the entered email with the temporary password and the link to the application."
      }
      postHandler={submitHandler}
      confirmButtonText={"Create User"}
      flag={flag}
      setFlag={setFlag}
    />
  )
}

export default CreateNewUserModal
